<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">Notes d'hospitalisation terminées</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableNoteArchive"
          identifier="B122TableNoteArchive"
          init-b122-table-url="/noteArchive/initB122Table"
          get-b122-table-results-url="/noteArchive/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(title)="data">
            <span> {{ data.item.title ? data.item.title : '-' }} </span>
          </template>

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <note-delete-modal :selected="ui.selected" @didDeleteNote="didDeleteNote()"></note-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import NoteDeleteModal from "../note/NoteDeleteModal";

export default {

  name: 'NoteArchiveIndex',

  components: {
    B122Table,
    NoteDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Date",
          key: "creationDate",
          sortable: true,
          formatter: function (value, key, item) {
            var date = new Date(value)
            return date.toLocaleString()
          }
        },
        {
          label: "Animal",
          key: "animal.name",
          sortKey: "hospitalization.animal.name",
          sortable: true
        },
        {
          label: "Propriétaire",
          key: "animal.user.name",
          sortKey: "hospitalization.animal.user.lastName",
          sortable: true
        },
        {
          label: "Titre",
          key: "title",
          sortable: true
        },
        {
          label: "Type",
          key: "type",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selected: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'NoteShow',
        params: {
          noteId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'NoteEdit',
        params: {
          noteId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selected = row.item
      this.$bvModal.show('note-delete-modal')
    },

    didDeleteNote() {
      this.ui.selected = null;
      this.$refs.B122TableNoteArchive.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/noteArchive/NoteArchiveIndex.vue